import React from 'react'
import styled from 'styled-components';
import { SkeletonCell } from '../../components/SkeletonCell';
import { useTheme } from '../../middleware/ThemeContext';

const SingleCriteriaResultSkeleton = () => {
    const {theme} = useTheme();
  return (
    <BoxContainer theme={theme}>
        <BoxHeader theme={theme}>
            <div className='d-flex gap-1'>
                <SkeletonCell style={{ width: '110px', height: '19px' }}  />
            </div>
            <div className='d-flex align-items-center'>
                <SkeletonCell style={{ width: '120px', height: '30px' }} />
                <Divider theme={theme} style={{ height: '25px', margin: '0px 15px' }} />
                    <SkeletonCell style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
            </div>
        </BoxHeader>
        <div style={{ padding: '20px 15px' }}>
            <SkeletonCell style={{ width: '120px', height: '15px', marginBottom: '10px' }} />
            <SkeletonCell style={{ width: '100%', height: '66px' }} />
            <div className='d-flex justify-content-end mt-3'>
                <SkeletonCell style={{ width: '135px', height: '44px' }} />
            </div>
        </div>
    </BoxContainer>
  )
}

const BoxContainer = styled.div`
    background-color: ${({theme}) => theme.colors.contentBackground};
    border: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    border-radius: 5px;
    // width: 456px;
`;

const BoxHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid ${({theme}) => theme.CorporateTheme.colors.border}
`;

const UserImages = styled.div`
    display: flex;
    align-items: center;
    // justify-content: center;
    
    span {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: -10px;
      border: 1px solid #ffffff;
    
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 50%;
      }
    }
    span.img-avatar{
        background-color: ${({theme}) => theme.CorporateTheme.colors.stackBg};
        color: #ffffff;
        font-size: 12px;
    }
`;

const Divider = styled.span`
    width: 1px;
    background-color: ${({theme}) => theme.CorporateTheme.colors.border};

`;

const ConCriteria = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${({theme}) => theme.CorporateTheme.colors.headerBG};
    border-radius: 5px;
    padding: 15px;
`;

export default SingleCriteriaResultSkeleton